import { render } from "./Settings.vue?vue&type=template&id=14a7baca&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=14a7baca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-14a7baca"

export default script